import React from "react";
import { useNavigate } from "react-router-dom";
import { CarbonImprove } from "../components/CarbonImprove";
import { IconParkTwotone } from "../components/IconParkTwotone";
import { MingcuteVoiceLine } from "../components/MingcuteVoiceLine";
import { RiQuestionLine } from "../components/RiQuestionLine";

const Desktop29 = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-[#f9f9f9] text-[#22033c] overflow-hidden w-full">
      {/* Hero Section */}
      <section className="relative w-full bg-gradient-to-b from-[#06010a] to-[#260345] text-white py-20 px-6 md:px-20 flex flex-col lg:flex-row items-center justify-between gap-12">
        {/* Left Text */}
        <div className="flex-1 space-y-6 max-w-xl">
          <h3 className="text-lg font-medium text-white/80">
            AI Interview Simulation
          </h3>

          <h1 className="text-4xl md:text-5xl font-semibold leading-snug">
            Practice your interviews as easily as talking to a real recruiter
          </h1>

          <p className="text-base md:text-lg text-white/80 leading-relaxed">
            Rehearse in a true-to-life interview setting and get supportive feedback on everything from
            the substance of your answers to your tone, pacing, and confidence.
          </p>

          <button
            onClick={() => navigate("/auth")}
            className="bg-[#ffc403] text-black font-bold px-6 py-3 rounded-xl hover:bg-[#e6b800] transition"
          >
            Get Started
          </button>
        </div>

        {/* Right Image */}
        <div className="flex-1 flex justify-center">
          <img
            src="https://c.animaapp.com/mgglelhkuCyG7h/img/image-60.png"
            alt="Interview Simulation"
            className="w-[85%] md:w-[420px] h-auto rounded-xl object-contain drop-shadow-2xl"
          />
        </div>
      </section>

      {/* Smart Interview Simulations Section */}
      <section className="bg-[#f9f9f9] py-20 px-6 md:px-16 text-center relative">
        <h2 className="text-3xl md:text-4xl font-semibold mb-3">
          Build confidence with smart interview simulations
        </h2>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-16">
          Boost your readiness and performance through real-time AI-powered
          conversations and feedback.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-10 md:gap-20 lg:gap-32">
          {/* Left Column */}
          <div className="flex flex-col items-end text-right space-y-12 max-w-xs md:max-w-sm">
            {/* 1 */}
            <div>
              <IconParkTwotone className="w-8 h-8 text-[#22033c] mb-2 ml-auto" />
              <h3 className="text-xl font-semibold mb-1">
                Real-Time AI Feedback
              </h3>
              <p className="text-gray-700 text-base">
                AI evaluates your tone, clarity, confidence, and relevance just
                like a professional interviewer.
              </p>
            </div>

            {/* 2 */}
            <div>
              <MingcuteVoiceLine className="w-8 h-8 text-[#22033c] mb-2 ml-auto" />
              <h3 className="text-xl font-semibold mb-1">Voice Interaction</h3>
              <p className="text-gray-700 text-base">
                Speak naturally — no typing required. AI listens, responds, and
                adjusts questions based on your answers.
              </p>
            </div>
          </div>

          {/* Center Image */}
          <div className="flex justify-center items-center">
            <img
              src="https://c.animaapp.com/mgglelhkuCyG7h/img/image-61.png"
              alt="AI Interview Simulation Example"
              className="w-[250px] md:w-[300px] lg:w-[360px] rounded-2xl shadow-xl object-contain"
            />
          </div>

          {/* Right Column */}
          <div className="flex flex-col items-start text-left space-y-12 max-w-xs md:max-w-sm">
            {/* 3 */}
            <div>
              <RiQuestionLine className="w-8 h-8 text-[#22033c] mb-2" />
              <h3 className="text-xl font-semibold mb-1">
                Role-Based Questioning
              </h3>
              <p className="text-gray-700 text-base">
                Select your job position or domain to receive role-specific
                interview questions tailored to your industry.
              </p>
            </div>

            {/* 4 */}
            <div>
              <CarbonImprove className="w-8 h-8 text-[#22033c] mb-2" />
              <h3 className="text-xl font-semibold mb-1">
                Personalized Improvement Tips
              </h3>
              <p className="text-gray-700 text-base">
                Learn exactly where to improve with AI-generated insights and
                model answers.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Desktop29;
